import { z } from "zod";

/**
 * The MCP `Implementation` a server names itself with (`serverInfo`). Every field
 * is server-authored and untrusted — a display string, never an identity.
 */
export const McpServerImplementationSchema = z.looseObject({
  name: z.string(),
  version: z.string(),
  title: z.string().optional()
});

export type McpServerImplementation = z.infer<typeof McpServerImplementationSchema>;
